import { Handshake } from 'lucide-react';
import AffiliateLinksPanel from '@/components/affiliates/AffiliateLinksPanel';

export default function AffiliatesPage() {
  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center gap-2">
        <Handshake className="h-5 w-5 text-indigo-400" />
        <div>
          <h1 className="text-xl font-semibold text-white">Affiliate Links</h1>
          <p className="text-xs text-ink-muted mt-0.5">
            All referral links across organizations and external partners
          </p>
        </div>
      </div>
      <AffiliateLinksPanel />
    </div>
  );
}
